export default {
  title: 'Page not found!',
  body: 'Oops! Looks like you’ve taken a wrong turn. This page doesn’t exist anymore—or maybe it never did. Let’s get you back on track.',
  dynamicBody: '{name} number is wrong, or may deleted',

  general: {
    labels: {
      backHome: 'Back to Home'
    },

    types: {
      user: 'User',
      receive: 'Receive',
      payment: 'Payment',
      cost: 'Cost',
      internalFund: 'Internal transfer',
      document: 'Document',
      purchase: 'Purchase invoice',
      purchaseRefund: 'Purchase refund invoice',
      sale: 'Sale invoice',
      saleRefund: 'Sale refund invoice',
      tax: 'Tax',
      warehouseReceipt: 'Delivery note',
      warehouseDeficit: 'Deficit',
      warehouseConversion: 'Conversion',
      attribute: 'Attribute',
      bank: 'Bank',
      cash: 'Cash',
      category: 'Category',
      character: 'User group',
      paymentGateway: 'Gateway',
      product: 'Product',
      service: 'Service'
    }
  }
}
